import React from 'react'
import NavBar from '../Home/Navbar'
import HeroSection from './HeroSection'
import NavigationTabs from './NavigationTabs'
import PaymentIntegrationTab from './PaymentIntegrationTab'
import { Box } from '@mui/material'
import OurProducts from './OurProducts'
import Footer from '../../Components/Footer'

const Developers = () => {
    return (
        <Box sx={{bgcolor:'#f8f8f8'}}>
            <NavBar textColor="#000000" logoTextColor="#000000" />
            <HeroSection />
            <NavigationTabs />
            <PaymentIntegrationTab />
            <OurProducts />
            <Footer />
        </Box>

    )
}

export default Developers